<template>
  <div class="dashboard-container">
    <div class="dashboard-text">欢迎使用OA系统</div>

    <!-- 审批汇总（全流程：不按 flowCode 过滤，与菜单下各审批分类页的 Tab 一致） -->
    <el-card class="approval-summary-card" shadow="never">
      <div slot="header" class="approval-card-header">
        <span>审批汇总</span>
        <div class="approval-header-actions">
          <el-date-picker
            v-model="approvalCreateTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="timestamp"
            :picker-options="approvalCreateTimePickerOptions"
            size="small"
            clearable
            style="width: 260px;"
          />
          <el-input
            v-model="approvalKeyword"
            placeholder="搜索流程标题或单号"
            style="width: 220px;"
            size="small"
            clearable
            @keyup.enter.native="handleApprovalSearch"
          />
          <el-button size="small" icon="el-icon-search" @click="handleApprovalSearch">搜索</el-button>
        </div>
      </div>
      <el-tabs v-model="approvalActiveTab" type="border-card" class="approval-tabs" @tab-click="handleApprovalTabChange">
        <el-tab-pane name="todo">
          <span slot="label" class="tab-label-with-badge">
            <i class="el-icon-bell"></i> 待我审批
            <el-badge
              v-if="approvalTodoCount > 0"
              :value="approvalTodoCount"
              :max="99"
              class="approval-todo-badge"
            />
          </span>
        </el-tab-pane>
        <el-tab-pane name="done">
          <span slot="label"><i class="el-icon-finished"></i> 我已审批</span>
        </el-tab-pane>
        <el-tab-pane name="mine">
          <span slot="label"><i class="el-icon-s-promotion"></i> 我发起的</span>
        </el-tab-pane>
      </el-tabs>
      <el-table v-loading="approvalLoading" :data="approvalList" border size="small" style="width: 100%; margin-top: -1px;">
        <el-table-column label="序列号" align="center" min-width="96">
          <template slot-scope="scope">
            <el-button type="text" class="serial-no-link" @click.stop="handleApprovalSerialClick(scope.row)">
              {{ approvalSerialDisplay(scope.row, scope.$index) }}
            </el-button>
          </template>
        </el-table-column>
        <!-- 流程类型列（暂不展示，需要时取消注释）
        <el-table-column label="流程类型" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.flowName || row.flowCode || '—' }}</span>
          </template>
        </el-table-column>
        -->
        <el-table-column label="流程标题" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.flowTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发起人" width="88" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.creatorName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="88" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="approvalStatusType(row.status)" size="mini" effect="plain">{{ approvalStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发起时间" width="142" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatApprovalTime(row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前节点" width="110" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.currentNodeTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column label="待处理人" min-width="110" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.pendingHandlerNames || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="168" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="approvalActiveTab === 'todo'" type="primary" size="mini" @click="handleApprovalApprove(row)">{{ row.approveActionLabel || '审批' }}</el-button>
            <el-button v-else type="primary" size="mini" plain @click="handleApprovalView(row)">查看</el-button>
            <el-button v-if="row.flowCode" type="text" size="mini" @click.stop="goApprovalCategory(row)">该类列表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="approval-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="approvalTotal"
          :page-size.sync="approvalPageSize"
          :current-page.sync="approvalPageNum"
          :page-sizes="[5, 10, 20]"
          :pager-count="5"
          @size-change="handleApprovalPageSizeChange"
          @current-change="fetchApprovalList"
        />
      </div>
    </el-card>

    <!-- 统计卡片（暂不展示，需要时取消注释）
    <div class="info-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="info-item">
            <div class="info-number">{{ stats.userCount }}</div>
            <div class="info-label">总用户数</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="info-item">
            <div class="info-number">{{ stats.departmentCount }}</div>
            <div class="info-label">总部门数</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="info-item">
            <div class="info-number">{{ stats.roleCount }}</div>
            <div class="info-label">总角色数</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="info-item">
            <div class="info-number">{{ stats.employeeCount }}</div>
            <div class="info-label">总员工数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    -->
    
    <div class="quick-links">
      <h3>快捷入口</h3>
      <el-row :gutter="20">
        <el-col :span="4" v-for="link in quickLinks" :key="link.name">
          <div class="link-item" @click="goToPage(link.path)">
            <div class="link-icon">
              <i :class="link.icon"></i>
            </div>
            <div class="link-text">{{ link.name }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// 统计卡片已注释时不必请求（恢复统计卡片时一并取消注释）
// import { getAllUsers } from '../../api/user'
// import { getAllDepartments } from '../../api/department'
// import { getAllRoles } from '../../api/role'
// import { getAllEmployees } from '../../api/employee'
import { getTodoList, getDoneList, getMineList } from '../../api/workflow'
import { getYearRangePickerOptions, toCreateTimeRangeParams } from '../../utils'

export default {
  name: 'Dashboard',
  data() {
    return {
      /* 统计卡片已注释时可去掉；恢复卡片时解开
      stats: {
        userCount: 0,
        departmentCount: 0,
        roleCount: 0,
        employeeCount: 0
      },
      */
      approvalActiveTab: 'todo',
      approvalKeyword: '',
      approvalCreateTimeRange: null,
      approvalLoading: false,
      approvalList: [],
      approvalTotal: 0,
      approvalPageNum: 1,
      approvalPageSize: 5,
      approvalTodoCount: 0
    }
  },
  computed: {
    ...mapGetters('user', ['menus']),
    approvalCreateTimePickerOptions() {
      return getYearRangePickerOptions()
    },
    quickLinks() {
      const list = Array.isArray(this.menus) ? this.menus : []
      return list
        .filter(menu => menu && menu.status !== 0 && menu.type !== 'C')
        .filter(menu => menu.component && menu.component.toLowerCase() !== 'layout/index')
        .map(menu => ({
          name: menu.menuName,
          path: this.normalizePath(menu.path),
          icon: menu.icon || 'el-icon-menu',
          orderNum: menu.orderNum,
          id: menu.id
        }))
        .sort((a, b) => {
          if (a.orderNum == null && b.orderNum == null) return (a.id || 0) - (b.id || 0)
          if (a.orderNum == null) return 1
          if (b.orderNum == null) return -1
          if (a.orderNum !== b.orderNum) return a.orderNum - b.orderNum
          return (a.id || 0) - (b.id || 0)
        })
    }
  },
  created() {
    // this.fetchStats()
    this.fetchApprovalList()
    this.fetchApprovalTodoCount()
  },
  activated() {
    this.fetchApprovalList()
    this.fetchApprovalTodoCount()
  },
  methods: {
    /* 恢复统计卡片时取消整段注释，并在 created 中调用 fetchStats()
    async fetchStats() {
      try {
        const [userRes, deptRes, roleRes, empRes] = await Promise.all([
          getAllUsers().catch(() => ({ data: [] })),
          getAllDepartments().catch(() => ({ data: [] })),
          getAllRoles().catch(() => ({ data: [] })),
          getAllEmployees().catch(() => ({ data: [] }))
        ])
        const users = Array.isArray(userRes.data) ? userRes.data : []
        const depts = Array.isArray(deptRes.data) ? deptRes.data : []
        const roles = Array.isArray(roleRes.data) ? roleRes.data : []
        const emps = Array.isArray(empRes.data) ? empRes.data : []
        this.stats.userCount = users.length
        this.stats.departmentCount = depts.length
        this.stats.roleCount = roles.length
        this.stats.employeeCount = emps.length
      } catch (e) {
        // 忽略统计错误，不影响首页其他功能
      }
    },
    */
    normalizePath(path) {
      const value = String(path || '').replace(/\\/g, '/').replace(/\/+/g, '/').trim()
      if (!value) return '/'
      return value.startsWith('/') ? value : `/${value}`
    },
    goToPage(path) {
      this.$router.push(path)
    },
    handleApprovalTabChange() {
      this.approvalPageNum = 1
      this.fetchApprovalList()
      this.fetchApprovalTodoCount()
    },
    handleApprovalSearch() {
      this.approvalPageNum = 1
      this.fetchApprovalList()
      this.fetchApprovalTodoCount()
    },
    handleApprovalPageSizeChange() {
      this.approvalPageNum = 1
      this.fetchApprovalList()
    },
    fetchApprovalList() {
      this.approvalLoading = true
      const params = {
        page: this.approvalPageNum - 1,
        size: this.approvalPageSize
      }
      if (this.approvalKeyword) params.keyword = this.approvalKeyword
      Object.assign(params, toCreateTimeRangeParams(this.approvalCreateTimeRange))
      const apiMap = { todo: getTodoList, done: getDoneList, mine: getMineList }
      const apiFn = apiMap[this.approvalActiveTab] || getTodoList
      apiFn(params)
        .then(res => {
          this.approvalList = res.data.content || []
          this.approvalTotal = res.data.totalElements || 0
          this.approvalLoading = false
        })
        .catch(() => { this.approvalLoading = false })
    },
    fetchApprovalTodoCount() {
      const params = { page: 0, size: 1 }
      if (this.approvalKeyword) params.keyword = this.approvalKeyword
      Object.assign(params, toCreateTimeRangeParams(this.approvalCreateTimeRange))
      getTodoList(params).then(res => {
        this.approvalTodoCount = res.data.totalElements || 0
      }).catch(() => {})
    },
    handleApprovalApprove(row) {
      this.$router.push({ path: '/approval/form', query: { flowIncId: row.id, mode: 'approve' } })
    },
    handleApprovalView(row) {
      this.$router.push({ path: '/approval/form', query: { flowIncId: row.id, mode: 'view' } })
    },
    handleApprovalSerialClick(row) {
      if (this.approvalActiveTab === 'todo') {
        this.handleApprovalApprove(row)
      } else {
        this.handleApprovalView(row)
      }
    },
    goApprovalCategory(row) {
      if (!row.flowCode) return
      this.$router.push({ path: `/approval/category/${encodeURIComponent(row.flowCode)}` })
    },
    approvalSerialDisplay(row, index) {
      const no = row && row.no != null ? String(row.no).trim() : ''
      if (no) return no
      return (this.approvalPageNum - 1) * this.approvalPageSize + index + 1
    },
    approvalStatusType(s) {
      if (s === 'running') return 'primary'
      if (s === 'finished') return 'success'
      if (s === 'terminated') return 'danger'
      return 'info'
    },
    approvalStatusText(s) {
      if (s === 'running') return '进行中'
      if (s === 'finished') return '已完成'
      if (s === 'terminated') return '已终止'
      return s || '-'
    },
    formatApprovalTime(ts) {
      if (!ts) return '-'
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  
  .dashboard-text {
    font-size: 24px;
    margin-bottom: 20px;
  }

  /* 统计卡片样式（卡片模板恢复时一并取消注释）
  .info-card {
    margin-bottom: 30px;

    .info-item {
      text-align: center;

      .info-number {
        font-size: 24px;
        font-weight: bold;
        color: #409EFF;
      }

      .info-label {
        margin-top: 10px;
        color: #909399;
      }
    }
  }
  */

  .approval-summary-card {
    margin-bottom: 28px;
    .approval-card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 12px;
    }
    .approval-header-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }
    .approval-tabs {
      border-bottom: none;
      ::v-deep .el-tabs__header {
        margin-bottom: 0;
      }
    }
    /* 红底数字角标：单数字近似正圆，多位数为圆角胶囊（与侧栏一致） */
    .tab-label-with-badge {
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }
    .approval-todo-badge {
      margin-left: 2px;
      vertical-align: middle;
    }
    ::v-deep .approval-todo-badge .el-badge__content {
      background-color: #f56c6c;
      color: #fff;
      border: none;
      height: 18px;
      min-width: 18px;
      padding: 0 5px;
      box-sizing: border-box;
      line-height: 18px;
      font-size: 12px;
      font-weight: 600;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      border-radius: 999px !important;
      transform: translateX(2px) translateY(0);
    }
    .serial-no-link {
      padding: 0;
      font-weight: 600;
      color: #409eff;
    }
    .serial-no-link:hover {
      color: #66b1ff;
    }
    .approval-pagination {
      margin-top: 14px;
      display: flex;
      justify-content: flex-end;
    }
  }

  .quick-links {
    h3 {
      margin-bottom: 20px;
    }
    
    .link-item {
      text-align: center;
      padding: 20px 10px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }
      
      .link-icon {
        i {
          font-size: 24px;
          color: #409EFF;
        }
      }
      
      .link-text {
        margin-top: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>